
const DefaultTranslation = {
    about: {
        pt_br: "Sobre",
        en_us: "About",
        es_es: "Sobre"
    },

    aboutUs: {
        pt_br: "Sobre nós",
        en_us: "About us",
        es_es: "Sobre nosotros"
    },

    changeLanguage: {
        pt_br: "Alterar idioma",
        en_us: "Change the language",
        es_es: "Cambia el idioma"
    },

    contact: {
        pt_br: "Contato",
        en_us: "Contact",
        es_es: "Contacto"
    },

    copyright: {
        pt_br: "© Copyright 2024. Todos os direitos reservados",
        en_us: "© Copyright 2024. All rights reserved",
        es_es: "© Copyright 2024. Todos los derechos reservados"
    },

    developedBy: {
        pt_br: "Desenvolvido por",
        en_us: "Developed by",
        es_es: "Desarrollado por"
    },

    email: {
        pt_br: "E-mail",
        en_us: "Email",
        es_es: "Email"
    },

    english: {
        pt_br: "Inglês",
        en_us: "English",
        es_es: "Inglés"
    },

    error: {
        pt_br: "Erro",
        en_us: "Error",
        es_es: "Error"
    },

    home: {
        pt_br: "Home",
        en_us: "Home",
        es_es: "Home"
    },

    information: {
        pt_br: "Informação",
        en_us: "Information",
        es_es: "Información"
    },

    informations: {
        pt_br: "Informações",
        en_us: "Informations",
        es_es: "Informaciónes"
    },

    message: {
        pt_br: "Mensagem",
        en_us: "Message",
        es_es: "Mensaje"
    },

    name: {
        pt_br: "Nome",
        en_us: "Name",
        es_es: "Nombre"
    },

    ourCatalog: {
        pt_br: "Nosso catálogo",
        en_us: "Our catalog",
        es_es: "Nuestro catalogo"
    },

    ourProducts: {
        pt_br: "Nossos produtos",
        en_us: "Our products",
        es_es: "nuestros productos"
    },

    phone: {
        pt_br: "Telefone",
        en_us: "Phone",
        es_es: "Teléfono"
    },

    portuguese: {
        pt_br: "Português",
        en_us: "Portuguese",
        es_es: "Portugués"
    },

    products: {
        pt_br: "Produtos",
        en_us: "Products",
        es_es: "Productos"
    },

    readMore: {
        pt_br: "Leia mais",
        en_us: "Read more",
        es_es: "Lea mas"
    },

    sales: {
        pt_br: "Vendas",
        en_us: "Sales",
        es_es: "Ventas"
    },

    send: {
        pt_br: "Enviar",
        en_us: "Send",
        es_es: "Enviar"
    },

    spanish: {
        pt_br: "Espanhol",
        en_us: "Spanish",
        es_es: "Español"
    },

    store: {
        pt_br: "Loja",
        en_us: "Store",
        es_es: "Tienda"
    },

    success: {
        pt_br: "Sucesso",
        en_us: "Success",
        es_es: "Éxito"
    },

    subject: {
        pt_br: "Assunto",
        en_us: "Subject",
        es_es: "Asunto"
    },

    technicalAssistance: {
        pt_br: "Assistência técnica",
        en_us: "Technical assistance",
        es_es: "Asistencia técnica"
    },

    timeLimitExceeded: {
        pt_br: "Limite de tempo excedido",
        en_us: "Time limit exceeded",
        es_es: "Límite de tiempo excedido"
    },

    warning: {
        pt_br: "Atenção",
        en_us: "Warning",
        es_es: "Advertencia"
    },
}

export default DefaultTranslation;